/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuilderNavigationService, CommonActions, ListActionPipelines } from '@gh/builder-shared';
import { BuilderPermissionSet } from '@gh/builder-shared-data';
import { getRouteInitData, UserContext } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { DialogService } from '@gh/core-ui';
import {
  EstimatingSalesTaxRateDetailsDialogConfig,
  EstimatingSalesTaxRatesTabBusinessService,
} from '../../resources/estimating-sales-tax-rates-tab-business.service';
import { SalesTaxRate } from '../../resources/estimating-sales-tax-rates-tab.model';
import { estimatingSalesTaxRateDetailsDialog } from '../estimating-sales-tax-rate-details-dialog/estimating-sales-tax-rate-details-dialog.route';
import { EstimatingSalesTaxRateListTabGridDefinition } from './estimating-sales-tax-rate-list-tab-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-estimating-sale-list-tax-rates-tab',
  templateUrl: 'estimating-sales-tax-rate-list-tab.component.html',
  styleUrls: ['estimating-sales-tax-rate-list-tab.component.scss'],
  viewProviders: [EstimatingSalesTaxRateListTabGridDefinition],
})
export class EstimatingSalesTaxRateListTabComponent implements OnInit {
  dataSource: SlicedDataSource<SalesTaxRate>;

  constructor(public gridDefinition: EstimatingSalesTaxRateListTabGridDefinition,
              private userContext: UserContext,
              private businessService: EstimatingSalesTaxRatesTabBusinessService,
              private pipelines: ListActionPipelines,
              private dialogService: DialogService,
              private commonActions: CommonActions,
              private navigationService: BuilderNavigationService,
              private route: ActivatedRoute) {
  }

  /**
   * Init component
   */
  ngOnInit(): void {
    const { gridLayout } = getRouteInitData(this.route);
    this.gridDefinition.bind(gridLayout);
    this.loadData();
  }

  loadData(): void {
    this.dataSource = this.businessService.findAllAsDataSource();
  }

  onCreate(): void {
    this.dialogService.openWithInput(estimatingSalesTaxRateDetailsDialog, {}).afterClosed()
      .subscribe((salesTaxRate) => {
        if (salesTaxRate) {
          this.loadData();
        }
      });
  }

  onEdit({ id }: SalesTaxRate): void {
    if (this.userContext.hasPermission(BuilderPermissionSet.Setup.Estimating.SalesTaxRates.EDIT_VIEW)) {
      const input = { id };
      this.dialogService
        .openWithInput(estimatingSalesTaxRateDetailsDialog, <EstimatingSalesTaxRateDetailsDialogConfig>input)
        .afterClosed()
        .subscribe((salesTaxRate) => {
          if (salesTaxRate) {
            this.loadData();
          }
        });
    }
  }

  goToAel(entityId?: ID, entityType?: string, label?: string): void {
    this.navigationService.goToAel({
      entityId: entityId || void 0,
      entityType: entityType ? entityType : 'SALES_TAX_RATE',
      label: label ? label : 'lbl_str',
    });
  }

}
